import { Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import CurrencyFormatter from 'components/fomatter/currency/currency-formatter';
import { isNil, lt } from 'lodash';
import React from 'react';

interface ExpandableCellProps {
    className: string;
    cellTitle: string;
    isCollapsedArrow?: boolean;
    shouldCollapse?: boolean;
    totalBalance: number | undefined;
}

const IncomeStatementStickyCell = (props: ExpandableCellProps) => {
    const { className, cellTitle, isCollapsedArrow, shouldCollapse, totalBalance } = props;

    return (
        <>
            <td className={clsx('page-container--table__sticky', className)}>
                <div
                    className={clsx('page-container--table-icon', {
                        COLLAPSED: shouldCollapse && isCollapsedArrow,
                        RETRACTED: shouldCollapse && !isCollapsedArrow
                    })}
                />
                <Tooltip title={cellTitle}>
                    <span>{cellTitle}</span>
                </Tooltip>
            </td>
            <td
                className={clsx('page-container--table__sticky', className, {
                    NEGATIVE_VALUES: lt(totalBalance, 0)
                })}
            >
                {!isNil(totalBalance) && <CurrencyFormatter value={totalBalance} prefix />}
            </td>
        </>
    );
};

export default IncomeStatementStickyCell;
